import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { CustomersDropDownData } from './customers-drop-down-model';

export class CustomersDropDownDataResponseModel extends GlobalResponseObject{
    data?: CustomersDropDownData[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data //CustomersDropDownData[]
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: CustomersDropDownData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
